export default "__VITE_ASSET__C0v3rWNS__"